import { ReactNode } from 'react';
import { css as emotionCSS } from '@emotion/react';
import { AppBar as MuiAppBar, AppBarProps as MuiAppBarProps } from '@mildang/mui';
import { Toolbar as Toolbar } from '@mildang/mui';
import { Theme } from '@mildang/mui';

const toolbarStyle = (theme: Theme) => emotionCSS`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  ${theme.breakpoints.down('sm')} {
    min-height: 48px;
    padding-left: 8px;
    padding-right: 8px;
  }
`;

export interface AppBarProps extends MuiAppBarProps {
  children?: ReactNode;
  disableGutters?: boolean;
  toolbarClassName?: string;
}

const AppBar = (props: AppBarProps) => {
  const { toolbarClassName, disableGutters, children, color = 'default', ...other } = props;
  return (
    <MuiAppBar position="sticky" color={color} elevation={color === 'transparent' ? 0 : 2} {...other}>
      <Toolbar className={toolbarClassName} disableGutters={disableGutters} css={toolbarStyle}>
        {children}
      </Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
